<template>
	<div class="orderList">
		<back-to :url="packageTour"></back-to>
		<section class="orderList-content">
			<!-- 选项卡 -->
			<div class="orderList-tabs">
				<span :class="current == 1 ?'currentActive':''" :data-current="1" @click="change(1)">
					<img :src="current == 1?'https://m.sweetour.com/images/mini/mini10.png':'https://m.sweetour.com/images/mini/mini9.png'"
						alt="">
					<p>全部订单</p>
				</span>
				<span :class="current == 2 ?'currentActive':''" :data-current="2" @click="change(2)">
					<img :src="current == 2 ? 'https://m.sweetour.com/images/mini/mini6.png':'https://m.sweetour.com/images/mini/mini5.png'"
						alt="">
					<p>待支付</p>
				</span>
				<span :class="current == 3 ?'currentActive':''" :data-current="3" @click="change(3)">
					<img :src="current == 3 ? 'https://m.sweetour.com/images/mini/mini2.png':'https://m.sweetour.com/images/mini/mini1.png'"
						alt="">
					<p>待出行</p>
				</span>
				<span :class="current == 4 ?'currentActive':''" :data-current="4" @click="change(4)">
					<img :src="current == 4 ? 'https://m.sweetour.com/images/mini/mini4.png':'https://m.sweetour.com/images/mini/mini3.png'"
						alt="">
					<p>待评价</p>
				</span>
				<span :class="current == 5 ?'currentActive':''" :data-current="5" @click="change(5)">
					<img :src="current == 5 ? 'https://m.sweetour.com/images/mini/mini8.png':'https://m.sweetour.com/images/mini/mini7.png'"
						alt="">
					<p>取消/退款</p>
				</span>
			</div>
			<!-- 列表 -->
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
				:immediate-check="false" class="orderList-list">
				<div class="orderList-item" v-for="(item,index) in list"
					@click="orderType == 5?$router.push({ path: '/orderStatus',query:{'orderId':item.DDinfoID,'orderType':orderType}}):$router.push({ path: '/orderDetail',query:{'orderId':item.DDinfoID,'orderType':orderType}})">
					<span class="orderList-item-t">
						<p>{{item.ProductType}}</p>
						<p>{{item.StatusName}}</p>
					</span>
					<span class="orderList-item-c">
						<span>
							<img v-lazy="item.ImageUrl" />
							<p>{{item.ProductName}}</p>
						</span>
						<span>￥{{item.Price}} </span>
					</span>
					<span class="orderList-item-b">订单编号:{{item.SerialNO}}
						<p @click.stop="goto(item.Buttons[0].Action,item.DDinfoID,item)"
							v-if="orderType == 5 && item.Buttons.length > 0">
							{{item.Buttons[0].ButtonText}}
						</p>
					</span>
				</div>
			</van-list>
		</section>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import BackTo from "@/components/BackTo";
	import {
		Toast
	} from 'vant'
	export default {
		name: 'orderList',
		components: {
			BackTo
		},
		data() {
			return {
				packageTour: '/',
				current: 1,
				loading: false,
				finished: false,
				pageIndex: 1,
				list: [],
				orderType: 1
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		created() {
			this.orderType = this.$route.query.orderType
		},
		mounted() {
			this.getList()
		},
		methods: {
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.pageIndex = this.pageIndex + 1
					this.getList()
				}, 500);
			},
			getList(e) {
				if (this.$route.query.orderType == 8) {
					var orgID = 60
				} else if (this.$route.query.orderType == 5) {
					var orgID = 0
				} else {
					var orgID = this.$organizationId
				}
				var data = {
					'userID': this.userInfo.userId,
					'type': this.current,
					'pageIndex': this.pageIndex,
					'source': 1,
					// 'orgID': [3, 7, 5, 6].indexOf(this.$route.query.orderType) == -1 ? this.organizationId : 0,
					'orgID': orgID,
					'p_type': this.$route.query.orderType
				}
				this.$_postNew(
					this.$apiWebsiteSweet + '/NewOrder/GetOrderStatusList', data
				).then(res => {
					if (e) {
						this.list = res.StatusListInfo
					} else {
						this.list = this.list.concat(res.StatusListInfo)
					}
					if (res.StatusListInfo.length < 10) {
						this.finished = true;
					}
				})
			},
			change(e) {
				console.log(e)
				if (e == this.current) {
					return
				}
				if (e == 5) {
					this.$router.push({
						path: '/refundList',
						query: {
							type: 1
						}
					})
					return
				}
				this.current = e
				window.scrollTo(0, 0)
				this.loading = false
				this.finished = false
				this.pageIndex = 1
				this.getList(true)
			},
			goto(e, orderId, myarray) {
				// console.log(myarray)
				if (e == 1) {
					// Toast("支付功能暂未开通")
					const toast = Toast.loading({
						duration: 0, // 持续展示 toast
						forbidClick: true,
						message: '支付中',
					});

					this.$post(
						this.$login + '/LST/CreateOrder', {
							'orderNo': myarray.SerialNO,
							"userId": '' + this.userInfo.lstUserId,
							"returnUrl": 'https://lst.sweetour.com/orderStatus?orderId=' + myarray.DDinfoID +
								'&orderType=' + this.$route.query.orderType + '&payTrue=true'
						}
					).then(res => {
						const url = res.py_URL
						window.location.href = url;
					})
				} else if (e == 5) {
					// 去评价
					var dataParam = {
						'orderId': orderId,
						'proID': myarray.ProductID,
						'proTypeID': myarray.ProductTypeID,
						'proImg': myarray.ImageUrl,
						'proTitle': myarray.ProductName,
						'proUserId': this.userInfo.userId
					}
					this.$router.push({
						path: '/evaluate',
						query: {
							dataParam: JSON.stringify(dataParam)
						}
					})
				} else {
					this.$router.push({
						path: '/call',
						query: {
							'orderId': orderId
						}
					})
				}
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#fff')
		},
	}
</script>

<style scoped>
	.orderList-content {
		margin-top: @nav-bar-height;
	}

	.orderList-tabs {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 120px;
		border-bottom: 1px solid #e6e6e6;
		font-size: 24px;
		position: fixed;
		top: @nav-bar-height;
		background-color: #fff;
	}

	.orderList-tabs img {
		width: 40px;
		height: 40px;
	}

	.orderList-tabs span {
		display: flex;
		align-items: center;
		flex-direction: column;
		flex: 1;
		padding-top: 14px;
	}

	.orderList-tabs span p {
		padding-top: 10px;
	}

	.currentActive {
		color: #ff983f;
		font-weight: bold;
	}

	.orderList-list {
		padding-top: 120px;
		font-size: 26px;
	}


	.orderList-item img {
		width: 200px;
		height: 132px;
		margin-right: 17px;
	}

	.orderList-item-t {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 72px;
		border-bottom: 1px solid #e6e6e6;
		color: #999;
		padding: 0 20px 0 32px;
		box-sizing: border-box;
	}

	.orderList-item-t p:last-child {
		color: #ff8a00;
	}

	.orderList-item-c {
		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		padding: 20px 20px 20px 32px;
		box-sizing: border-box;
		border-bottom: 1px solid #e6e6e6;
	}

	.orderList-item-c span:first-child {
		display: flex;
		color: #333;
		font-weight: bold;
	}

	.orderList-item-b {
		height: 88px;
		border-bottom: 14px solid #e6e6e6;
		width: 100%;
		display: flex;
		align-items: center;
		padding-left: 32px;
		box-sizing: border-box;
	}

	.orderList-item-b p {
		height: 48px;
		border: 1px solid #b3b3b3;
		margin: 10px 25px 0 0;
		text-align: center;
		line-height: 48px;
		border-radius: 50px;
		padding: 0 20px;
		color: #aaa;
		margin-left: auto;
	}
</style>